import Driver from 'driver.js'
import Vue from 'vue'

const DRIVER = (Name,Opacity) => {
  const DriverInstance = new Driver({
    allowClose: false,
    doneBtnText: '完成', // Text on the final button
    closeBtnText: '关闭引导', // Text on the close button for this step
    nextBtnText: '下一步', // Next button text for this step
    prevBtnText: '上一步',
    driverName:Name,
    opacity:Opacity || 0.75,
    onReset:function () {
      localStorage.setItem(Name,Name)
    }
  })
  
  
  const Step =  {
    HomeOrigin : [
      {
        element: '#studyroom',
        popover: {
          className: 'style1',
          title: '欢迎来到“电商选品虚拟仿真实验”',
          description: '首先，点击学习室了解跨境电商的相关知识',
          position: 'top'
        }
      }
    ],
    StudyRoom : [
      {
        element: '#studyCourse',
        popover: {
          className: 'style1',
          title: '在学习室，我们可以点击“进入学习”，了解到跨境电商相关知识。',
          description: '',
          position: 'top'
        }
      }
    ],
    HomeStart : [
      {
        element: '#start',
        popover: {
          className: 'style1',
          title: '通过学习室的学习，让我们对跨境电商有了初步的了解，现在点击“开始实验”进行跨境电商的模拟操作吧',
          description: '点击“开始实验”',
          position: 'right'
        }
      }
    ],
    DataSource1 : [
      {
        element: '#shopeeContainer',
        popover: {
          className: 'style1',
          title: '数据分析步骤的第一步是了解数据的获取来源，本实验模拟Shopee平台进行实验，下面开始操作吧',
          description: '点击“下一步”',
          position: 'left',
        }
      },
      {
        element: '#searchWrap',
        popover: {
          className: 'style1',
          title: '你可以在搜索框中输入关键字进行搜索，也可以直接点击系统推荐热门搜索词进行搜索',
          description: '点击“下一步”',
          position: 'left'
        }
      },
      {
        element: '#sellerItem',
        popover: {
          className: 'style1',
          title: '“SHOPEE”平台上需要关注的两个地方，我们先来了解一下竞争商家的数量以及商家的基本情况',
          description: '',
          position: 'left'
        }
      },
      {
        element: '#shop-statistics-item-sales',
        popover: {
          className: 'style1',
          title: '商家“总销量”',
          description: '',
          position: 'left'
        }
      },
      {
        element: '#shop-statistics-item-evaluate',
        popover: {
          className: 'style1',
          title: '商家“总评价”',
          description: '',
          position: 'left'
        }
      },
      {
        element: '#moreLink',
        popover: {
          className: 'style1',
          title: '点击“查看更多”可以查看多个商家的详细情况',
          description: '',
          position: 'left',
          showButtons: false,
        },
        onNext:function () {
          console.log('点击“查看更多”可以查看多个商家的详细情况')
        }
      },
      {
        element: '#sellerContent',
        popover: {
          className: 'style1',
          title: '这里可以查看其他竞争卖家的数量和基本情况',
          description: '请点击“返回”',
          position: 'left',
          showButtons: false,
        },
        onPrevious:()=>{
        
        }
      },
      {
        element: '#dataLocation',
        popover: {
          className: 'style1',
          title: '这里我们可以了解“SHOPEE”平台关键数据的位置',
          description: '请点击选择“消费力”',
          position: 'right',
          showButtons: false
        },
        onNext:function () {

        }
      },
      {
        element: '#productPrice',
        popover: {
          className: 'style1',
          title: '消费力的数据体现在“SHOPEE”的商品价格上',
          description: '请依次点击“总销量”，“卖家数量”，“总评价”，分辨关键数据的位置',
          position: 'top',
        },
        onNext:function () {

        }
      }
    ],
    DataSource2:[
      {
        element: '#submitBtn',
        popover: {
          className: 'style1',
          title: '系统已自动抓取“SHOPEE”平台的关键数据',
          description: '请点击“生成数据”进行下一步吧',
          position: 'top',
        },
        onNext:function () {

        }
      }
    ],
    Generate:[
      {
        element: '#Content',
        popover: {
          className: 'style1',
          title: '你可以查看收集到的Shopee平台上关于Tea的四个维度数据',
          description: '请点击“下一步”',
          position: 'right',
        },
        onNext:function () {

        }
      },
      {
        element: '#submitBtn',
        popover: {
          className: 'style1',
          title: '点击进入东南亚国家的数据对比分析页面',
          description: '',
          position: 'top',
          showButtons: false,
        },
        onNext:function () {

        }
      }
    ],
    Comparison1:[
      {
        element: '#TableWrap',
        popover: {
          className: 'style1',
          title: '东南亚国家的数据对比',
          description: '请点击“下一步”',
          position: 'left',
        },
        onNext:function () {

        }
      },
      {
        element: '#btnWrap',
        popover: {
          className: 'style1',
          title: '你也可以进入图标界面进行分析',
          position: 'left',
          showButtons: false
        },
        onNext:function () {

        }
      },
    ],
    Comparison2:[
      {
        element: '#CountryList',
        popover: {
          className: 'style1',
          title: '可以点击不同国家进行切换',
          description: '请点击“下一步”',
          position: 'right',

        },
        onHighlighted:function () {
          document.querySelector('.v-modal').style.opacity = 0
        }
      },
    ],
    Comparison3:[
      {
        element: '#upLoadProductWrap',
        popover: {
          className: 'prevvvv',
          title: '通过图表数据的对比选择合适的产品与它热销的国家，并进行商品基础信息的填写(最多可以选择3中产品)',
          description: '现在点击“完成”，开始产品信息填写吧',
          position: 'right',
        }
      }
    ],
    Putaway1:[
      {
        element: '#DataLocation',
        popover: {
          className: 'style1',
          title: '进行产品上架操作（选中产品后点击“上架商品”按钮）',
          description: '开始操作吧',
          position: 'right',
        },
      },
      {
        element: '#ProductWrapper',
        popover: {
          className: 'style1',
          title: '在Shopee界面可以看到上架后的产品',
          description: '',
          position: 'top',
        },
      }
    ]
  };

  DriverInstance.defineSteps(Step[Name])
  return DriverInstance
}
Vue.prototype.Driver = DRIVER

export default DRIVER
